
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/live-policy",
      function () {
        return require("private-next-pages/terms/live-policy/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/live-policy"])
      });
    }
  